import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { ExploreTheForumCardStyles } from '@stories/Components/ExploreTheForumCard/ExploreTheForumCard.styles';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) ``;
const CardsGrid = styled.div `
  display: grid;
  grid-template-columns: auto;
  gap: ${fluid(16, 40)};

  &:has(${ExploreTheForumCardStyles.Container}:hover) {
    ${ExploreTheForumCardStyles.Container}:not(:hover) {
      opacity: 0.6;
    }
  }

  &:has(${ExploreTheForumCardStyles.Container}:focus-visible) {
    ${ExploreTheForumCardStyles.Container}:not(:focus-visible) {
      opacity: 0.6;
    }
  }

  ${ExploreTheForumCardStyles.Container} {
    &[data-index='0'] {
      grid-row: 3;
    }
  }

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(3, 1fr);

    ${ExploreTheForumCardStyles.Container} {
      &[data-index='0'] {
        grid-row: 1;
      }

      &[data-index='1'] {
        grid-column: 2 / span 2;
      }

      &[data-index='2'] {
        grid-row: 2 / span 2;
      }
    }
  }
`;
export const ExploreTheForumStyles = {
    CardsGrid,
    Container,
};
